import { IAdminContact } from '../contacts/IAdminContact';
import { IDefaultContactRoles } from './CreateDefaultContact';
import { IContactUSAStates } from '../contacts/IContactUSAStates';

export interface IDefaultContactRequest {
  id: string;
  roles: IDefaultContactRoles;
  notes?: string;
  admin: IAdminContact;
  clientCompany: null | { id: string; name: string }; // API returns null for this field
}

export type IDefaultContactData = IDefaultContactRequest;

export type IPresentationDefaultContact = IDefaultContactData & {
  role: string;
  states: Array<IContactUSAStates>;
  key: number;
};

export const getListOfPresentationDefaultContacts = (
  data: IDefaultContactData[],
): IPresentationDefaultContact[] => {
  // Since we are duplicating the id of the contact, we need to have something that's unique
  let nextKey = 0;
  const dataArray: IPresentationDefaultContact[] = [];
  data.forEach((contact) =>
    Object.keys(contact.roles).forEach((roleKey) =>
      dataArray.push({ ...contact, role: roleKey, states: contact.roles[roleKey] ?? [], key: nextKey++ }),
    ),
  );
  return dataArray;
};

export const convertFromIDefaultContactRequestToIDefaultContactData = (
  data: IDefaultContactRequest,
): IDefaultContactData => data;

export const convertFromIDefaultContactDataToIDefaultContactRequest = (
  data: IDefaultContactData,
): IDefaultContactRequest => data;

export const convertFromIDefaultContactRequestArrayToIDefaultContactDataArray = (
  data: IDefaultContactRequest[],
): IDefaultContactData[] => data.map((d) => convertFromIDefaultContactRequestToIDefaultContactData(d));

export const convertFromIDefaultContactDataArrayToIDefaultContactRequestArray = (
  data: IDefaultContactData[],
): IDefaultContactRequest[] => data.map((d) => convertFromIDefaultContactDataToIDefaultContactRequest(d));
